// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__vH-24","buttons":"Contact_buttons__KnAl3"};